import * as React from 'react';

function SvgShowVideo(props) {
  return (
    <svg width={14} height={14} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#show-video_svg__clip0_2270_71192)">
        <path
          d="M13.25 3.727l-2 1.152V2.504a1 1 0 00-1-1H1a1 1 0 00-1 1v9a1 1 0 001 1h9.25a1 1 0 001-1V9.129l2 1.152a.5.5 0 00.75-.432V4.16a.5.5 0 00-.75-.433zm-3.125 7.652h-9v-8.75h9v8.75zm2.75-2.61l-1.625-.934v-1.66l1.625-.937V8.77zM2.25 4.63H4a.125.125 0 00.125-.125v-.75A.125.125 0 004 3.629H2.25a.125.125 0 00-.125.125v.75c0 .069.056.125.125.125z"
          fill="#000"
          fillOpacity={0.45}
        />
      </g>
      <defs>
        <clipPath id="show-video_svg__clip0_2270_71192">
          <path fill="#fff" d="M0 0h14v14H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgShowVideo;
